$(document).ready(function () {

	/*
	 * Testimonials slider
	 */
	var owl = $(".testimonials-slider").owlCarousel({
		center: true,
		loop: true,
		items: 3,
		rtl: true,
		autoWidth: true,
		mouseDrag: false,
	});
	// next button
	$('.testimonials-nav .next').click(function (e) {
		owl.trigger('next.owl.carousel');

		e.preventDefault()
	});
	// previous button
	$('.testimonials-nav .prev').click(function (e) {
		owl.trigger('prev.owl.carousel');

		e.preventDefault()
	});

	/*
	 * Sidemenu
	 */
	// Open menu
	$('.sidemenu-btn').click(function () {
		$('.sidemenu, .sidemenu-overly').addClass('active');

		// Stop overflow
		$('body').css('overflow', 'hidden')
	});
	// Close menu
	$('.sidemenu-close, .sidemenu-overly').click(function () {
		$('.sidemenu, .sidemenu-overly').removeClass('active');

		// Set overflow
		$('body').css('overflow', 'auto')
	});

	/*
	 * Walkthrough Steps
	 */
	var walkthroughSteps = $('.walkthrough-step');
	walkthroughSteps.click(function () {
		// Remove active from all steps
		walkthroughSteps.removeClass('active');
		// Add active to the clicked step
		$(this).addClass('active');
		changeWalkthroughScreen(this);
	});

	// Change walkthrough screen images
	function changeWalkthroughScreen(elem) {
		targetID = $(elem).data('target');
		$(targetID).siblings().removeClass('active')
		$(targetID).addClass('active');
	}

	// Steps scroll works only on medium screen size
	if ( $(window).width() >= 768 ) {

		var controller = new ScrollMagic.Controller();

		// create a scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#walkthrough-section',
			duration: 600,
			offset: 400
		})
			.setPin('#walkthrough-section')
			.addTo(controller);


		var currentPosition, indecationPoint, currentStep = 0;
		scene.on("progress", function (e) {
			currentPosition = e.progress * scene.duration()
			indecationPoint = (scene.duration() / walkthroughSteps.length) * (currentStep + 1)

			// Next step on scroll down
			if (currentPosition > indecationPoint && e.scrollDirection == "FORWARD") {
				currentStep += 1;
				walkthroughSteps[Math.abs(currentStep)].click()
			}

			// Previous step on scroll up
			if (currentPosition < indecationPoint && e.scrollDirection == "REVERSE") {
				walkthroughSteps[Math.abs(currentStep)].click()
				currentStep -= 1;
			}

			// Remove scene and controller a scene's end
			if (currentPosition == scene.duration()) {
				scene.destroy(true)
				controller.destroy(true)
			}
		});
	}

});